import {Injectable} from '@angular/core';
import {NotificationAlertsMessage} from './notification-alerts-message.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationAlertsService {
    private readonly planSaveSuccess: NotificationAlertsMessage = new NotificationAlertsMessage({
        type: 'success',
        text: 'The plan has been saved successfully',
        timeout: 3000
    });

    private readonly snapShotSuccess: NotificationAlertsMessage = new NotificationAlertsMessage({
        type: 'success',
        text: 'Snapshot created',
        timeout: 3000
    });

    private readonly prefSaveSuccess: NotificationAlertsMessage = new NotificationAlertsMessage({
        type: 'success',
        text: 'Preferences have been saved successfully',
        timeout: 3000
    });

    title = 'Notification Alerts Service';

    messages: NotificationAlertsMessage[] = [];

    messageTimeoutMap: Map<NotificationAlertsMessage, number> = new Map<NotificationAlertsMessage, number>();

    addMessage(partialNotificationAlertMessage: Partial<NotificationAlertsMessage>) {
        const subType = partialNotificationAlertMessage.subType;
        if (subType && this.messages.some(message => message.subType === subType)) {
            return;
        }
        this.addMessageWithTimeout(new NotificationAlertsMessage(partialNotificationAlertMessage));
    }

    removeMessage(message: NotificationAlertsMessage) {
        const messageIndex = this.messages.indexOf(message);
        if (messageIndex !== -1) {
            this.messages.splice(messageIndex, 1);
            if (this.messageTimeoutMap.has(message)) {
                window.clearTimeout(this.messageTimeoutMap.get(message));
                this.messageTimeoutMap.delete(message);
            }
        }
    }

    showPlanSaveSuccess() {
        if (!this.messages.includes(this.planSaveSuccess)) {
            this.addMessageWithTimeout(this.planSaveSuccess);
        }
    }

    showSnapshotSaveSuccess() {
        if (!this.messages.includes(this.snapShotSuccess)) {
            this.addMessageWithTimeout(this.snapShotSuccess);
        }
    }

    showPreferencesSaveSuccess() {
        if (!this.messages.includes(this.prefSaveSuccess)) {
            this.addMessageWithTimeout(this.prefSaveSuccess);
        }
    }

    hasMessageType(type: string): boolean {
        return this.messages.some(message => message.subType === type);
    }

    private addMessageWithTimeout(message: NotificationAlertsMessage) {
        if (this.messageTimeoutMap.has(message)) {
            window.clearTimeout(this.messageTimeoutMap.get(message));
        }

        this.messages.push(message);

        this.messageTimeoutMap.set(
            message,
            window.setTimeout(() => this.removeMessage(message), message.timeout)
        );
    }
}
